import { Component, OnInit } from '@angular/core';

import { UserService } from '../services/user/user.service';
import { User } from '../models/user.model';

@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {

    user: User

    constructor(
        private userService: UserService
    ) { }

    ngOnInit() {
        this.userService.loadUser().then(user => {
            this.user = user
            console.log(user)
        })
    }

}



// WEBPACK FOOTER //
// ./src/app/user/user.component.ts